import { CloseInfoIcon } from '@/assets/icons/info-icons/closeInfo';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';

interface BannerProps {
  icon: React.ReactNode;
  title: string;
  description: React.ReactNode;
  bgColor: string;
  descriptionFontSize?: string;
  color?: string;
  withBorderRadius?: boolean;
  dividerColor?: string;
  closeIconColor?: string;
  endImpersonation?: () => void;
  onClose?: () => void;
}

export const Banner = ({
  icon,
  title,
  description,
  bgColor,
  descriptionFontSize,
  color,
  withBorderRadius,
  dividerColor,
  closeIconColor,
  endImpersonation,
  onClose
}: BannerProps) => {
  return (
    <StatusBannerWrapper bgColor={bgColor} withBorderRadius={withBorderRadius}>
      <IconWrapper>{icon}</IconWrapper>
      <BannerDivider dividerColor={dividerColor} />
      <StatusWrapper>
        <Status color={color}>{title}</Status>
        <Description color={color} descriptionFontSize={descriptionFontSize}>
          {description}
        </Description>
      </StatusWrapper>
      {endImpersonation && (
        <EndImpersonationIconWrap onClick={endImpersonation}>
          <CloseInfoIcon width={18} height={18} fill={themeVar('context.warning')} />
        </EndImpersonationIconWrap>
      )}
      {onClose && (
        <CrossIconWrap onClick={onClose}>
          <CloseInfoIcon width={14} height={14} fill={closeIconColor || themeVar('context.light')} />
        </CrossIconWrap>
      )}
    </StatusBannerWrapper>
  );
};

export const StatusBannerWrapper = styled.div<{ bgColor: string; withBorderRadius?: boolean }>`
  background: ${({ bgColor }) => bgColor};
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 10px 20px;
  border-radius: ${({ withBorderRadius }) => (withBorderRadius ? '10px' : '0')};
`;

export const BannerDivider = styled.div<{ dividerColor?: string }>`
  width: 1px;
  min-width: 1px;
  min-height: 46px;
  height: 100%;
  background-color: ${({ dividerColor }) => dividerColor || themeVar('context.light')};
`;

export const StatusWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Status = styled.span<{ color: string }>`
  color: ${({ color }) => color || themeVar('context.light')};
  font-weight: 700;
  font-size: 16px;
`;

export const Description = styled.span<{ color: string; descriptionFontSize?: string }>`
  color: ${({ color }) => color || themeVar('context.light')};
  font-weight: 400;
  font-size: ${({ descriptionFontSize }) => descriptionFontSize || '13px'};
  white-space: pre-line;
`;

const EndImpersonationIconWrap = styled.div`
  background-color: ${themeVar('layer.base')};
  width: 50px;
  height: 50px;
  border-radius: 25px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
`;

const CrossIconWrap = styled.div`
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
